import styled from 'styled-components';

export const TextAreaWrapper = styled.div`
  text-align: left;

  textarea {
    max-height: 120px;
  }
`;
